import React, { useState } from 'react';
import { EyeIcon, EyeOffIcon, CopyIcon, CheckIcon } from 'lucide-react';
interface Props {
  apiKey: string;
}
export const ApiKeySection = ({
  apiKey
}: Props) => {
  const [showKey, setShowKey] = useState(false);
  const [copied, setCopied] = useState(false);
  const handleCopy = async () => {
    await navigator.clipboard.writeText(apiKey);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  const maskApiKey = (key: string) => {
    return `${key.slice(0, 5)}${'•'.repeat(20)}${key.slice(-4)}`;
  };
  return <div className="space-y-4 bg-surface-light border border-surface-border p-6 rounded-none" data-id="element-1245">
      <div data-id="element-1246">
        <h3 className="text-lg font-medium text-white font-mono" data-id="element-1247">API Key</h3>
        <p className="text-sm text-gray-400 mt-1" data-id="element-1248">
          Use this key to authenticate API requests to your Knowledge Space
        </p>
      </div>
      <div className="flex items-center gap-4" data-id="element-1249">
        <div className="flex-1 relative" data-id="element-1250">
          <input type={showKey ? 'text' : 'password'} value={showKey ? apiKey : maskApiKey(apiKey)} readOnly className="w-full px-4 py-2 bg-surface border border-surface-border rounded-none text-white font-mono text-sm" data-id="element-1251" />
          <button onClick={() => setShowKey(!showKey)} className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-300 transition-colors" data-id="element-1252">
            {showKey ? <EyeOffIcon size={16} data-id="element-1253" /> : <EyeIcon size={16} data-id="element-1254" />}
          </button>
        </div>
        <button onClick={handleCopy} className="flex items-center gap-2 px-4 py-2 bg-surface border border-surface-border text-white font-mono text-sm hover:bg-surface-mid transition-colors rounded-none" data-id="element-1255">
          {copied ? <>
              <CheckIcon size={16} className="text-status-success" data-id="element-1256" />
              <span data-id="element-1257">Copied!</span>
            </> : <>
              <CopyIcon size={16} data-id="element-1258" />
              <span data-id="element-1259">Copy</span>
            </>}
        </button>
      </div>
      <div className="flex items-center gap-2 text-sm" data-id="element-1260">
        <div className="w-2 h-2 bg-status-success rounded-none" data-id="element-1261" />
        <span className="text-gray-400" data-id="element-1262">Active and ready to use</span>
      </div>
    </div>;
};